import {useParams} from "react-router-dom";
import {Tooltip, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {useContext} from "react";
import {currentProject, ProjectContext} from "../ProjectProvider";
import {EventEmitter} from "nate-react-api-helpers";
import {formatProjectNumber} from "../../../api/Projects";

export function ProjectName() {
    const project = useProject();

    return (<div style={{
        paddingRight: 8,
    }}>
        <Tooltip title={project?.name || ""}>
            <Typography variant="h3" style={{
                fontSize: "1.1rem", fontWeight: 500, color: grey["800"],
                maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
            }}>
                {project && project.projectNumber > 0 && <span style={{color: grey["600"], marginRight: 8}}>{formatProjectNumber(project.projectNumber)}</span>}
                {project?.name}
            </Typography>
        </Tooltip>
    </div>)
}

export function useProjectId() {
    const params = useParams<{project: string}>();
    try {
        if(!params.project) return 0;

        const v = parseInt(params.project, 10);
        if(isNaN(v)) return 0;
        return v;

    } catch (e) {
        return 0;
    }
}

export function useProject() {
    const proj = useContext(ProjectContext);

    const projEmit = EventEmitter.reactValue(currentProject);
    if(proj.value.id !== 0) return proj.value;

    // if not inside of <ProjectProvider> fallback
    return projEmit;
}

export function useProjectUnitSystem() {
    const proj = useProject();
    if(!proj) return null;
    return proj.unitSystem || "imperial";
}